import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';

const mapServerToSolutionsSpecifications = (serverVariant, brand)=>{
    const { lensTypeTarget , caseIncluded , minimumCycleTime , preservativeFree , maxTimeFrameInLensCase , expirationAfterOpening , packageOption ,  } = serverVariant.variantTypeDetails;
    const serverSpecifications = {
        lensTypeTarget,
        caseIncluded,
        minimumCycleTime,
        preservativeFree,
        maxTimeFrameInLensCase,
        expirationAfterOpening,
        packageOption
    };
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems(serverSpecifications), 
    ];
};

export { mapServerToSolutionsSpecifications };
//# sourceMappingURL=map-server-to-solutions-specifications.js.map
